import { useEffect, useState } from 'react';
import { tryFetch } from '../../../Helpers/FetchAPI';

interface Product {
  id: string;
  store_id: string;
  product_id: string;
  product_name: string;
  product_type: string;
  product_slug: string;
  product_description: string;
  unit_price: string;
  media: { media_url: string }[];
  legal_age: boolean;
  is_sale: boolean;
  sale_price: string;
  sale_price_with_admin_fee: string;
  merchant_slug: string;
}

const useSale = () => {
  const [saleProducts, setSaleProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const saleRes = await tryFetch({
          url: '/gottsulit',
          method: 'GET',
        });

        if (saleRes.is_success && Array.isArray(saleRes.data)) {
          setSaleProducts(saleRes.data as Product[]);
        } else {
          setError('Failed to fetch sale products');
        }
      } catch (err) {
        console.error('Error fetching sale products:', err);
        setError('Failed to load sale products');
      } finally {
        setLoading(false);
      }
    };

    fetchSales();
  }, []);

  return { saleProducts, loading, error };
};

export default useSale;
